import { render, staticRenderFns } from "./rangaistukset.vue?vue&type=template&id=105048de&scoped=true&"
import script from "./rangaistukset.vue?vue&type=script&lang=js&"
export * from "./rangaistukset.vue?vue&type=script&lang=js&"
import style0 from "./rangaistukset.vue?vue&type=style&index=0&id=105048de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105048de",
  null
  
)

export default component.exports